import { useCompanySetting } from 'hooks/use.company.setting'
import React, { useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useAppDispatch } from 'store'
import { logout } from 'store/auth'

const parseTimeout = (value: any): number => {
  if (!Number(value) || value < 1) {
    return 1
  }

  return Math.min(value * 60 * 1000, 2147483647) // Max 32 Bit Int
}

export const ActivityListener: React.FC = () => {
  const { value: logoutOnInactive } = useCompanySetting('force_logout_after_min_inactive')
  const dispatch = useAppDispatch()

  const { start, pause } = useIdleTimer({
    onIdle() {
      void dispatch(logout())
    },
    startManually: true,
    timeout: parseTimeout(logoutOnInactive),
  })

  useEffect(() => {
    if (!Number(logoutOnInactive)) {
      pause()
      return
    }
    start()
  }, [logoutOnInactive])

  const { value: logoutOnReopen } = useCompanySetting('force_logout_on_reopen')

  useEffect(() => {
    if (!logoutOnReopen) {
      return
    }

    const cb = () => {
      void dispatch(logout())
    }

    window.addEventListener('beforeunload', cb)

    return () => window.removeEventListener('beforeunload', cb)
  }, [logoutOnReopen])

  return null
}
